import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import { isEngineN1tro, isEngineTmgaming } from 'common/shared';

const cacheBuster = process.env.REACT_APP_GIT_HASH || new Date().getTime();

let ns = ['common'];


if (isEngineTmgaming) {
    ns = ['tmgaming'];
}
if (isEngineN1tro) {
    ns = ['n1tro'];
}

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json?ver=' + cacheBuster,
        },

        supportedLngs: ['en', 'id', 'th'],
        debug: false,
        lng: localStorage.i18nextLng,
        fallbackLng: 'en',

        // have a common namespace used around the full app
        ns: ns,
        defaultNS: ns[0],
        nsSeparator: false,

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ',',
        },
    });

export default i18n;
